import { esusApi } from "@/services/api";

export type ResumeIndicatorC3Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorC3Data {
	totalPregnantsAndPuerperals: number = 0;
	totalPregnantsAndPuerperalsScore: number = 0;
	maxPregnantsAndPuerperalsScore: number = 0;
	totalPuerperals: number = 0;
	totalPuerperalsScore: number = 0;
	maxPuerperalsScore: number = 0;
}

export async function getResumeIndicatorC3({ uf, ibgeCode, ...params }: ResumeIndicatorC3Params) {
	const response = await esusApi.get<ResumeIndicatorC3Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c3/resume`,
		params
	);
	return response.data ?? new ResumeIndicatorC3Data();
}
